import React from "react";
import { NavLink } from "react-router-dom";
import logoImg from "../logo.svg";
import { Icon } from "react-icons-kit";
import { menu } from "react-icons-kit/feather/menu";
import { arrowLeft } from "react-icons-kit/feather/arrowLeft";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import axios from "axios";
import { useJwt } from "react-jwt";
import { CreateMedia, GetProductStatus } from "../apiconfig/authService";

function AddMedia(props) {
  const navigate = useNavigate();
  const { _, isExpired } = useJwt(localStorage.getItem("accessToken"));
  if (isExpired) navigate("/");

  const setMediaTableViewMessage = props.setMessage;

  const [mediaTitle, setMediaTitle] = useState("");
  const [mediaImage, setMediaImage] = useState(null);
  const [statusid, setStatusid] = useState(1);
  const [statusData, setStatusData] = useState(null);

  const [message, setMessage] = useState("");
  const [isMessageRed, setIsMessageRed] = useState("");

  const handleTitleChange = (e) => {
    setMediaTitle(e.target.value);
  };

  // console.log('mediaImage',mediaImage)
  const handleImageChange = (e) => {
    setMediaImage(e.target.files[0]);
  };

  const handleStatusIdChange = (e) => {
    setStatusid(e.target.value);
  };

  const validateInput = () => {
    if (mediaTitle === "") throw new Error("Name is required.");
    if (mediaImage === null) throw new Error("Image is required.");
  };

  const handleSubmitClick = async (e) => {
    e.preventDefault();

    try {
      validateInput();
    } catch (error) {
      setIsMessageRed(true);
      setMessage(error.message);
      window.scrollTo(0, 0);
      return;
    }

    let response;
    const formData = new FormData();
    formData.append("title", mediaTitle);
    formData.append("Image", mediaImage);
    formData.append("statusid", statusid);
    console.log("formData????????", formData);
    try {
      response = await CreateMedia(
        formData,
        localStorage.getItem("accessToken")
      );
      if (response.status === 201) {
        setMediaTableViewMessage(response.data.message);
        navigate("/media");
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        setIsMessageRed(true);
        setMessage(err.response.data.error);
        window.scrollTo(0, 0);
      } else {
        setIsMessageRed(true);
        setMessage("An error occurred. Please try again later.");
        window.scrollTo(0, 0);
      }
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const statusResponse = await GetProductStatus(
          localStorage.getItem("accessToken")
        );
        setStatusData(statusResponse.data);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  return (
    <div className="dashboard-content">
      <Sidebar />
      {/* <div className="mobileOption d-flex align-items-center justify-content-between">
          <div  className="buyMore">
            <img className="img-fluid" src={logoImg} alt=""/>
          </div>
          <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={menu} size={25}/></button>
        </div> */}
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Add Media</h1>
          <div className="d-inline-flex gap-2">
            <NavLink to="/media" className="btn btn-primary">
              View All
            </NavLink>
          </div>
        </div>

        {message && (
          <div
            style={{ color: isMessageRed ? "red" : "black" }}
            className="alert alert-primary"
            role="alert"
          >
            {message}
          </div>
        )}

        <div
          role="tabpanel"
          className="personal-info tab-pane active storetab"
          id="pi"
        >
          {/* <h4 className="text-primary h6 fw-bold mb-3">Product main category information</h4> */}
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="catName">Media Title</label>
              <input
                type="text"
                value={mediaTitle}
                onChange={handleTitleChange}
                className="form-control custom-input my-2"
                id="catName"
                placeholder="Media Title"
              />
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              <label htmlFor="catImg">Media Image</label>
              <input
                type="file"
                className="form-control custom-input my-2"
                onChange={handleImageChange}
                id="catImg"
                placeholder="Media Image"
              />
            </div>
          </div>

          <label htmlFor="floatingInput">Status</label>
          <select
            className="form-select custom-input my-2"
            onChange={handleStatusIdChange}
            value={statusid}
          >
            {statusData?.map((item) => (
              <option value={item.statusid}>{item.status}</option>
            ))}
          </select>

          <div className="row">
            <div className="form-group col-sm-12 col-lg-12 mb-3">
              <button
                type="submit"
                onClick={handleSubmitClick}
                className="btn btn-primary save-btn text-uppercase px-4 my-3"
              >
                Add
              </button>
            </div>
          </div>
        </div>
        <hr />
      </div>
    </div>
  );
}
export default AddMedia;
